import { Route, Routes } from "react-router-dom";
import NotFound from "../not-found/NotFound";
import ContactUs from "../contact-us/ContactUs";
import DigitalMarketingService from "../pages/Service/digital-marketing-service/DigitalMarketingService";
import { AppConstant } from "../../AppConstant";
import WebDevelopment from "../pages/Service/web-development/WebDevelopment";
import MobileAppDevelopment from "../pages/Service/mobile-app-development/MobileAppDevelopment";
import AiDevelopment from "../pages/Service/ai-development/AiDevelopment";
import ItConsulting from "../pages/Service/it-consulting/ItConsulting";
import ECommerceDevelopment from "../pages/Service/e-commerce/ECommerceDevelopment";
import UIDevelopment from "../pages/Service/ui-development/UIDevelopment";
import HireDedicated from "../pages/Service/hire-dedicated/HireDedicated";
import MfHome from "../Home/MfHome";
import MFAbout from "../about/MFAbout";

const AeonRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MfHome />} />
      <Route path={AppConstant.ROUTES.ABOUT} element={<MFAbout />} />
      <Route path={AppConstant.ROUTES.CONTACT} element={<ContactUs />} />
      {/* <Route path={AppConstant.ROUTES.SERVICES.PROVIDE_SERVICES} element={<ServiceDetailSection />}/> */}
      <Route path={AppConstant.ROUTES.SERVICES.DIGITAL_MARKETING} element={<DigitalMarketingService />} />
      <Route path={AppConstant.ROUTES.SERVICES.WEB_DEVELOPMENT} element={<WebDevelopment />} />
      <Route path={AppConstant.ROUTES.SERVICES.APP_DEVELOPMENT} element={<MobileAppDevelopment />} />
      <Route path={AppConstant.ROUTES.SERVICES.AI_DEVELOPMENT} element={<AiDevelopment />} />
      <Route path={AppConstant.ROUTES.SERVICES.IT_CONSULTING} element={<ItConsulting />} />
      <Route path={AppConstant.ROUTES.SERVICES.ECOMMERCE} element={<ECommerceDevelopment />} />
      <Route path={AppConstant.ROUTES.SERVICES.UI_DESIGN} element={<UIDevelopment />} />
      <Route path={AppConstant.ROUTES.SERVICES.HIRE_DEDICATED} element={<HireDedicated />} />
      {/* <Route path={AppConstant.ROUTES.SERVICES.AMAZON_ACCOUNT_MANAGEMENT} element={<AmazonAccountManagementService />} />
      <Route path={AppConstant.ROUTES.SERVICES.AMAZON_BRAND_REGISTRY} element={<AmazonBrandRegistryService />} />
      <Route path={AppConstant.ROUTES.SERVICES.ADVERTISE_PPC} element={<AdvertisePPCService />} />
      <Route path={AppConstant.ROUTES.SERVICES.AMAZON_A_PLUS} element={<APlusContentService />} /> */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AeonRoutes;
